import { SingleProductDescriptionFocused } from "@/components/singleProduct/singleProductDescriptionFocused";
import { SingleProductImageFocused } from "@/components/singleProduct/singleProductImageFocused";

export const CategoryItems = ({
  category,
  merchantName,
  itemTemplate,
  itemsMap,
  query,
  handleItemClick,
}: any) => {
  const filteredSearchItems = category.items.filter((itemId: any) => {
    const item = category.id !== "Uncategorized" ? itemsMap[itemId] : itemId;
    return item && item.name.toLowerCase().includes(query?.toLowerCase());
  });
  if (filteredSearchItems.length === 0) {
    return null;
  }
  return (
    <div key={category.id} className="" id={category.name}>
      <h2 className="mt-8 mb-5 font-medium text-[15px] text-[#5C5C5C]">
        {String(category.name).toUpperCase()}
      </h2>
      <div
        className={[
          "grid",
          "grid-cols-1",
          "gap-x-8",
          "gap-y-10",
          "xl:gap-x-8",
          "justify-center",
          `${
            itemTemplate?.toLowerCase() == "image focused" &&
            "grid-cols-2 sm:grid-cols-2 lg:grid-cols-4"
          }`,
          `${
            itemTemplate?.toLowerCase() == "description focused" &&
            " grid-cols-1 sm:grid-cols-1 lg:grid-cols-2"
          }`,
        ].join(" ")}
      >
        {filteredSearchItems.map((itemId: any) => {
          const item =
            category.id !== "Uncategorized" ? itemsMap[itemId] : itemId;
          if (
            !item ||
            !item.name.toLowerCase().includes(query?.toLowerCase())
          ) {
            return null;
          }

          return (
            <div key={item.id} onClick={() => handleItemClick(item)}>
              {itemTemplate?.toLowerCase() == "description focused" && (
                <SingleProductDescriptionFocused
                  merchantName={merchantName}
                  product={item}
                />
              )}
              {itemTemplate?.toLowerCase() == "image focused" && (
                <SingleProductImageFocused product={item} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
